export default "__VITE_ASSET__7lax_VM0__"